import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Portals its children into the app header's full-width slot below the main
 * row (`#app-header-below`, rendered by PageLayout). Unlike HeaderLeftPortal
 * (which fills only the left cell of the header row), this spans the entire
 * header width — under the patient name AND across to the "Log out" cluster.
 * Used for a compact patient context strip. Renders nothing until the slot
 * node exists.
 */
export const HeaderBelowPortal = ({ children }: { children: ReactNode }) => {
  const [node, setNode] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setNode(document.getElementById('app-header-below'));
  }, []);
  return node ? createPortal(children, node) : null;
};
